import { useMemo } from "react";
import useInitialUserQuery from "./use-initial-user-query";
import useUserPermissions from "./use-user-permissions";

const usePermissions = () => {
  const { data } = useInitialUserQuery();
  const getPermissions = useUserPermissions();
  const { permissions, can } = useMemo(() => getPermissions(data), [data, getPermissions]);

  return { role: data.role, permissions, can };
};

export default usePermissions;
